import React from "react";
import { Link } from "react-router-dom";

const Relaxtion25 = () => {
  return (
    <section className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md col-span-4">
      <div className="h-full px-3 py-4 overflow-y-auto">
        <div>
          <p className="text-[#314C1C] text-2xl px-4 pb-3 font-crimson-pro font-bold">
            RELAXATION
          </p>
          <p className="text-[#314C1C] text-lg px-4 font-semibold">DURATION</p>
          <p className="text-[#314C1C] text-md px-4 font-semibold">
            How long will it take you to relax?
          </p>
        </div>
        <div className="text-center">
          <div className="flex justify-center gap-4 p-4">
            {/* First Card Column */}
            <div className="flex flex-col items-center mx-6">
              {/* Card 1 */}
              <div className="w-40 h-32 bg-white rounded-lg shadow-md mb-6 p-2 flex flex-col justify-center items-center">
                <Link to="../relaxation5">
                  <p className="text-[#314C1C] text-lg font-semibold text-center">
                    1
                  </p>
                  <p className="text-[#314C1C] text-lg font-semibold text-center">
                    minutes
                  </p>
                </Link>
              </div>
              {/* Card 2 */}
              <div className="w-40 h-32 bg-white rounded-lg shadow-md mb-6 p-2 flex flex-col justify-center items-center">
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  10
                </p>
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  minutes
                </p>
              </div>
            </div>
            {/* Second Card Column */}
            <div className="flex flex-col items-center mx-6">
              {/* Card 3 */}
              <div className="w-40 h-32 bg-white rounded-lg shadow-md mb-6 p-2 flex flex-col justify-center items-center">
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  3
                </p>
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  minutes
                </p>
              </div>
              {/* Card 4 */}
              <div className="w-40 h-32 bg-white rounded-lg shadow-md mb-6 p-2 flex flex-col justify-center items-center">
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  15
                </p>
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  minutes
                </p>
              </div>
              {/* Card 5 */}
              <div className="w-40 h-32 bg-white rounded-lg shadow-md mb-6 p-2 flex flex-col justify-center items-center">
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  30
                </p>
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  minutes
                </p>
              </div>
            </div>
            {/* Third Card Column */}
            <div className="flex flex-col items-center mx-6">
              {/* Card 6 */}
              <div className="w-40 h-32 bg-white rounded-lg shadow-md mb-6 p-2 flex flex-col justify-center items-center">
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  5
                </p>
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  minutes
                </p>
              </div>
              {/* Card 7 */}
              <div className="w-40 h-32 bg-white rounded-lg shadow-md mb-6 p-2 flex flex-col justify-center items-center">
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  20
                </p>
                <p className="text-[#314C1C] text-lg font-semibold text-center">
                  minutes
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Relaxtion25;
